import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { environment } from 'src/environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { TokenService } from 'src/app/services/getData_token.service';


@Component({
  selector: 'app-ai-search',
  templateUrl: './ai-search.component.html',
  styleUrls: ['./ai-search.component.css'],
})
export class AiSearchComponent implements OnInit {
  loading: boolean = false;
  selected: string = 'ai-search';
  email: any;
  userQuestion: string = '';
  Object = Object;
  apiUrl = `${environment.apiConfig.uri}/admin/AdminClientContact/generate-sql`;
  existingData:any;
  selectedQuestionIndex: number | null = null;
  displayLoader: boolean = true;
  clearingChat: boolean = false;


  constructor(private http: HttpClient, private authService: MsalService, private sanitizer: DomSanitizer, private tokenService: TokenService) {}
  ngOnInit(): void {
    const userDetails = this.tokenService.getUserDetails();
    if (userDetails) {
      this.email = userDetails.email;
    }
    this.getSearchData();
  }

  clearChat() {
    this.clearingChat = true;
    this.http.delete(`${environment.apiConfig.uri}/admin/AdminClientContact/DeleteChatHistory?email=${this.email}`)
      .subscribe({
        next: () => {
          this.userQuestion = '';
          this.existingData = [];
          this.clearingChat = false;
        },
        error: () => {
          this.userQuestion = '';
          this.clearingChat = false;
        }
      });
  }

  async getSearchData() {
    const prevDataUrl = `${environment.apiConfig.uri}/admin/AdminClientContact/getChatHistory?email=${this.email}`;
    try {
      this.displayLoader = true;
      const response: any = await this.http.get(prevDataUrl).toPromise();
      // Transform the chat history data
      this.existingData = response?.data?.map((item: any) => {
        try {
          const parsedAnswer = JSON.parse(item.answer);
          //  this.displayLoader = false;
          
          // If the answer already contains rawData, keep the original structure
          if (parsedAnswer.rawData) {
            return {
              question: item.question,
              answer: JSON.stringify({
                extraParam: {},
                isSuccess: true,
                message: "Chat history retrieved successfully",
                data: {
                  rawData: parsedAnswer.rawData,
                  message: parsedAnswer.response || parsedAnswer.message
                }
              })
            };
          }
          // If no rawData, maintain the original answer
          return {
            question: item.question,
            answer: item.answer
          };
        } catch (error) {
          // If parsing fails, return original item
          return error; 
        }
        finally {
          this.displayLoader = false;
        }
      }) || [];
    } catch (error) {
      console.error('Error fetching response:', error);
    }
    this.displayLoader = false;

  }

  selectQuestion(index: number) {
    this.selectedQuestionIndex = this.selectedQuestionIndex === index ? null : index;
  }

  parseResponse(answer: string): any {
    if (!answer) return {};
    
    try {
      const parsed = JSON.parse(answer);
      
      // Handle case where data is a direct string
      if (typeof parsed.data === 'string') {
        return { data: { message: parsed.data } };
      }
      
      // Handle case where rawData is in the response
      if (parsed.rawData) {
        return {
          data: {
            rawData: parsed.rawData,
            message: parsed.response || parsed.message
          }
        };
      }
      
      return parsed;
    } catch (e) {
      return { response: answer };
    }
  }

  async askQuestion() {
    if (!this.userQuestion.trim()) return;
    this.loading = true;
    const params = {
      UserQuestion: this.userQuestion,
      email: this.email
    };
    try {
      const response: any = await this.http.get(this.apiUrl, { params }).toPromise();
      // Check if response has error or null data
      if (!response.isSuccess || response.data === null) {
        // Add error message to chat
        this.existingData = [...(this.existingData || []), {
          question: this.userQuestion,
          answer: JSON.stringify({
            data: "Sorry, I couldn't process your request. Please try again later.",
            isSuccess: false
          })
        }];
      } else {
        // Add successful response to chat
        this.existingData = [...(this.existingData || []), {
          question: this.userQuestion,
          answer: JSON.stringify(response)
        }];
      }
      
      this.selectedQuestionIndex = this.existingData.length - 1;
      this.userQuestion = '';
    } catch (error) {
      console.error('Error fetching response:', error);
      // Add error message to chat for exceptions
      this.existingData = [...(this.existingData || []), {
        question: this.userQuestion,
        answer: JSON.stringify({
          data: "Sorry, I couldn't process your request. Please try again later.",
          isSuccess: false
        })
      }];
      this.selectedQuestionIndex = this.existingData.length - 1;
      this.userQuestion = '';
    } finally {
      this.loading = false;
    }
  }
  
  getDisplayText(answer: string): any {
    if (!answer) return '';
    
    try {
        const parsed = JSON.parse(answer);
        
        // Handle different response formats
        let text = '';
        
        // Case 1: Direct string in data
        if (typeof parsed.data === 'string') {
            text = parsed.data;
        }
        // Case 2: Response in data object
        else if (parsed.data?.response) {
            text = parsed.data.response;
        }
        // Case 3: Message in data object
        else if (parsed.data?.message) {
            text = parsed.data.message;
        }
        // Case 4: Message at root level
        else if (parsed.message) {
            text = parsed.message;
        }

        if (!text) {
            console.warn('No text content found in response:', parsed);
            return 'No response available';
        }

        // Apply formatting
        text = text
            .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
            .replace(/(\d+\. )/g, '<br>$1')
            .replace(/(\- )/g, '<br>• ')
            .replace(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi, '<a href="mailto:$1">$1</a>')
            .replace(/(\+?\d[\d\s-]+)/g, '<span class="phone-number">$1</span>')
            .replace(/(?:\r\n|\r|\n)/g, '<br>')
            .replace(/\s{2,}/g, ' &nbsp;')
            .replace(/(\w+):\s/g, '<strong>$1:</strong> ');
        
        return this.sanitizer.bypassSecurityTrustHtml(text);
    } catch (e) {
        console.error('Error parsing answer:', e);
        return 'Error displaying response';
    }
}

  getResponseText(data: any): string {
    if (!data) return '';
    if (typeof data === 'string') return data;
    return data?.response || data?.message || '';
}

getTableData(data: any): any[] {
  if (!data) return [];
  
  // Direct check for rawData
  if (data.rawData && Array.isArray(data.rawData)) {
    return data.rawData;
  }
  
  // List of possible property names that could contain the array data
  const possibleArrayProps = ['rawData', 'sample', 'data', 'results', 'items','table'];
  
  // Find the first property that exists and contains an array
  const arrayProp = possibleArrayProps.find(prop => 
    data[prop] && (Array.isArray(data[prop]) || typeof data[prop] === 'object')
  );
  
  if (!arrayProp) return [];
  
  return Array.isArray(data[arrayProp]) ? data[arrayProp] : [data[arrayProp]];
}

  getTableHeaders(data: any[]): string[] {
    if (!data || !data.length) return [];
    return Object.keys(data[0] || {});
  }
}
